export const dateToAwsDate = (date) => {
    const nd = new Date(date);
    const month = nd.getMonth() < 9 ? '0' + (nd.getMonth() + 1) : (nd.getMonth() + 1);
    const day = nd.getDate() < 9 ? '0' + nd.getDate() : nd.getDate();
    const result = `${nd.getFullYear()}-${month}-${day}`
    return result;
}